import { useEffect, useState } from "react";
import { Plus, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, btn } from "@/components/ui-kit";
import { PartnerCard } from "@/components/partners/PartnerCard";
import { PartnerDialog } from "@/components/partners/PartnerDialog";
import { IdocDialog } from "@/components/partners/IdocDialog";
import { PricingDialog } from "@/components/partners/PricingDialog";

export default function Partners() {
  const { user } = useAuth();
  const isMgr = user?.role === "manager";
  const [data, setData] = useState({ partners: [], message_types: {} });
  const [edit, setEdit] = useState(null);
  const [idoc, setIdoc] = useState(null);
  const [pricing, setPricing] = useState(null);
  const amazonSetup = () => api.post("/amazon/setup").then((r) => { toast.success(r.data.created.length ? `Created: ${r.data.created.join(", ")}` : "Amazon is already set up"); load(); }).catch((e) => toast.error(errMsg(e)));
  const load = () => api.get("/partners").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-6" data-testid="partners-page">
      <PageHeader title="Trading Partners" subtitle="Each partner has its own AS2 connection, certificate, test / production IDs, sites and message types. Incoming files are matched to a partner by AS2 ID and ISA sender ID; outgoing 940s use the partner that owns the order's site.">
        {isMgr && !(data.partners.find((p) => p.code === "AMAZON")?.pricing?.ex_works) && <Button variant="ghost" onClick={amazonSetup} className={btn.ghost} data-testid="amazon-setup-btn"><ShoppingCart className="mr-1.5 h-4 w-4" /> {data.partners.some((p) => p.code === "AMAZON") ? "Add Amazon under-4-pallet pricing" : "Load Amazon setup"}</Button>}
        {isMgr && <Button onClick={() => setEdit({})} className={btn.primary} data-testid="partner-add-btn"><Plus className="mr-1.5 h-4 w-4" /> Add partner</Button>}
      </PageHeader>
      <div className="space-y-4">
        {data.partners.map((p) => (
          <PartnerCard key={`${p.code}-${JSON.stringify(p.messages)}`} p={p} types={data.message_types} isMgr={isMgr} onEdit={setEdit} onChanged={load} onIdoc={setIdoc} onPricing={setPricing} />
        ))}
      </div>
      <PartnerDialog open={!!edit} onOpenChange={(v) => !v && setEdit(null)} partner={edit?.code ? edit : null} types={data.message_types} defaults={data.kind_defaults} onSaved={load} />
      <IdocDialog partner={idoc} onOpenChange={(v) => !v && setIdoc(null)} onSaved={load} />
      <PricingDialog partner={pricing} onOpenChange={(v) => !v && setPricing(null)} />
    </div>
  );
}
